import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  VENDORS_MODULE_REFRESH: createSagaAction('VENDORS_MODULE_REFRESH'),
  CREATE_NEW_VENDOR: createSagaAction('CREATE_NEW_VENDOR'),
  UPDATE_SAVED_VENDOR: createSagaAction('UPDATE_SAVED_VENDOR'),
  DELETE_VENDOR: createSagaAction('DELETE_VENDOR'),
  // notes
  GET_VENDOR_NOTE: createSagaAction('GET_VENDOR_NOTE'),
  CREATE_VENDOR_NOTE: createSagaAction('CREATE_VENDOR_NOTE'),
  EDIT_VENDOR_NOTE: createSagaAction('EDIT_VENDOR_NOTE'),
  DELETE_VENDOR_NOTE: createSagaAction('DELETE_VENDOR_NOTE'),

  // attachments
  UPLOAD_VENDOR_ATTACHMENT: createSagaAction('UPLOAD_VENDOR_ATTACHMENT'),
  GET_VENDOR_ATTACHMENTS: createSagaAction('GET_VENDOR_ATTACHMENTS'),
  UPDATE_VENDOR_ATTACHMENT_DESCRIPTION: createSagaAction('UPDATE_VENDOR_ATTACHMENT_DESCRIPTION'),
  DELETE_VENDOR_ATTACHMENT: createSagaAction('DELETE_VENDOR_ATTACHMENT')
}

// Action Creators
export const actions = {
  vendorsRefresh: () => ({ type: constants.VENDORS_MODULE_REFRESH.ACTION }),
  createNewVendor: ({ vendor, userId }) => ({
    type: constants.CREATE_NEW_VENDOR.ACTION,
    vendor,
    userId
  }),
  updateSavedVendor: ({ company, companyId, userId }) => ({
    type: constants.UPDATE_SAVED_VENDOR.ACTION,
    company,
    companyId,
    userId
  }),
  deleteVendor: ({ companyId }) => ({
    type: constants.DELETE_VENDOR.ACTION,
    companyId
  }),
  // notes
  getVendorNote: ({ vendorId }) => ({
    type: constants.GET_VENDOR_NOTE.ACTION,
    vendorId
  }),
  createVendorNote: ({ content, userId, vendorId }) => ({
    type: constants.CREATE_VENDOR_NOTE.ACTION,
    content,
    userId,
    vendorId
  }),
  editVendorNote: ({ content, noteId, vendorId }) => ({
    type: constants.EDIT_VENDOR_NOTE.ACTION,
    content,
    noteId,
    vendorId
  }),
  deleteVendorNote: ({ noteId, vendorId }) => ({
    type: constants.DELETE_VENDOR_NOTE.ACTION,
    noteId,
    vendorId
  }),
  // Attachment actions
  uploadAttachment: ({ formData, vendorId }) => ({
    type: constants.UPLOAD_VENDOR_ATTACHMENT.ACTION,
    formData,
    vendorId
  }),

  getVendorAttachments: ({ vendorId }) => ({
    type: constants.GET_VENDOR_ATTACHMENTS.ACTION,
    vendorId
  }),

  updateAttachmentDescription: ({ attachmentId, vendorId, description, userId }) => ({
    type: constants.UPDATE_VENDOR_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    vendorId,
    description,
    userId
  }),

  deleteAttachment: ({ attachmentId, vendorId }) => ({
    type: constants.DELETE_VENDOR_ATTACHMENT.ACTION,
    attachmentId,
    vendorId
  }),

  getVendorActivities: ({ vendorId }) => ({
    type: constants.GET_VENDOR_ACTIVITIES.ACTION,
    vendorId
  })
}

// Reducer
const initialState = [
  {
    name: ''
  }
]

export default createReducer(initialState, (state, { type, payload }) => {
  switch (type) {
    default:
      return state
    case constants.VENDORS_MODULE_REFRESH.SUCCESS:
      return { ...state, payload }
    case constants.CREATE_NEW_VENDOR.SUCCESS:
      return { ...state }
    case constants.UPDATE_SAVED_VENDOR.SUCCESS:
      return { ...state }
    case constants.DELETE_VENDOR.SUCCESS:
      return { ...state }

    // NOTES
    case constants.GET_VENDOR_NOTE.SUCCESS:
      return { ...state, vendorNotes: payload }

    case constants.CREATE_VENDOR_NOTE.ACTION:
      return { ...state }
    case constants.CREATE_VENDOR_NOTE.SUCCESS:
      return {
        ...state
      }
    case constants.EDIT_VENDOR_NOTE.ACTION:
      return { ...state }
    case constants.EDIT_VENDOR_NOTE.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_VENDOR_NOTE.ACTION:
      return { ...state }
    case constants.DELETE_VENDOR_NOTE.SUCCESS:
      return {
        ...state
      }

    // ATTACHMENTS
    case constants.UPLOAD_VENDOR_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_VENDOR_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_VENDOR_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_VENDOR_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        vendorAttachments: payload,
        loadingAttachments: false
      }

    case constants.UPDATE_VENDOR_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_VENDOR_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_VENDOR_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/vendorsActions.js